import React, { Component }  from 'react'
import Badge from 'material-ui/Badge';

const colors = {
	"primary": "#BA68C8",
	"secondary": "#3cd2ae"
}

export default class CountBadge extends Component{
	render(){
        let { props } = this
        let colors= props.primary ? "rgb(255, 64, 129)" : props.secondary ? "#3cd2ae" : "rgb(180,180,180)"
		return(
           <Badge
               style={{...props.style}}
               badgeStyle={{backgroundColor: colors, color:"white"}}
               badgeContent={props.badgeContent}
               primary={props.primary}
               secondary={props.secondary}
           />
		)}
}



// WEBPACK FOOTER //
// ./src/components/Badge.js